import React from 'react';

function ResultPage({ result, sessionType, questions, onDone }) {
  const registration = sessionType === 'registration';
  const official = sessionType === 'official';
  const dryRun = sessionType === 'dry-run';

  return (
    <div className="login-overlay">
      <div className="login-card confirmation-card">
        <div className="confirmation-header">
          <img src="/napcon_logo2.jpeg" alt="NAPCON 2026" className="napcon-logo confirmation-logo" />
          <div className="confirmation-badge">{registration ? 'Registration Received' : official ? 'Submission Received' : 'Dry Run Complete'}</div>
          <h1>{registration ? 'Thank You' : official ? 'Quiz Submitted' : 'Practice Result'}</h1>
          <p className="confirmation-subtitle">
            {registration ? 'Your NAPCON team registration has been submitted successfully.' : official ? 'Your Online Quiz has been submitted successfully.' : 'Your Dry Run has been saved. Each team can attempt it once.'}
          </p>
        </div>
        {official && <p className="confirmation-note">Your score will be reviewed by the organizers. You can close this page now.</p>}
        {dryRun && (
          <div className="confirmation-panel">
            <div className="confirmation-row"><span>Score</span><strong>{result.score} / {result.total}</strong></div>
            <div className="confirmation-row"><span>Correct answers</span><strong>{result.correctAnswers}</strong></div>
            <div className="confirmation-row"><span>Incorrect answers</span><strong>{result.wrongAnswers}</strong></div>
            <div className="confirmation-row"><span>Unattempted</span><strong>{result.unattempted}</strong></div>
          </div>
        )}
        {dryRun && result.review && (
          <div className="dry-run-review">
            <h3>Answer Review</h3>
            <ol>
              {result.review.map(({ questionIndex, correctIndex }) => (
                <li key={questionIndex}><strong>{questions[questionIndex]?.text}</strong><br />Correct answer: {questions[questionIndex]?.options[correctIndex]}</li>
              ))}
            </ol>
          </div>
        )}
        {registration && <p className="confirmation-note">You will receive confirmation and your team number through email.</p>}
        <button className="submit-btn logout-btn" onClick={onDone}>{dryRun ? 'Back to Home' : 'Done'}</button>
      </div>
    </div>
  );
}

export default ResultPage;
